import React from 'react';
import { useTranslation } from 'react-i18next';
import { Box, DocumentsIcon, Preloader, Text } from '@common-fe/common-fe';

import { MAX_SIZE_OF_FILE_IN_MEGABYTES } from '@/common/constants';

interface Props {
  isLoading?: boolean;
}

const UseMyMoneyDropScanContent: React.FC<Props> = ({ isLoading }) => {
  const { t } = useTranslation();

  return (
    <Box data-testId="drop-scan-content" align="center" justify="center">
      {isLoading ? (
        <Box width="100px" height="100px">
          <Preloader testId="drop-scan-content_preloader" />
        </Box>
      ) : (
        <DocumentsIcon width="150" height="100" />
      )}

      <Text
        data-testId="drop-scan-content_title"
        margin={{ top: 'spacing8' }}
        size="2xl"
        weight={700}
      >
        {isLoading ? t('Uploading...') : t('Drop files to attach them to your claim')}
      </Text>

      <Text
        data-testId="drop-scan-content_allowed-file-type"
        margin={{ top: 'spacing8' }}
        color="textSecondary"
      >
        {t('PDF, HEIF, JPEG')}
      </Text>

      <Text
        data-testId="drop-scan-content_max-file-size"
        margin={{ top: 'spacing2' }}
        color="textSecondary"
      >
        {t('Max. file size: ')}
        {MAX_SIZE_OF_FILE_IN_MEGABYTES}MB
      </Text>
    </Box>
  );
};

export default UseMyMoneyDropScanContent;
